// ─── Shared constants and helpers for Ebook components ───────────────────────

export const IC = {
  back:      'M19 12H5M12 5l-7 7 7 7',
  book:      'M4 19.5A2.5 2.5 0 0 1 6.5 17H20M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z',
  chevD:     'M6 9l6 6 6-6',
  chevU:     'M18 15l-6-6-6 6',
  chevR:     'M9 18l6-6-6-6',
  chevL:     'M15 18l-6-6 6-6',
  x:         'M18 6L6 18M6 6l12 12',
  check:     'M20 6L9 17l-5-5',
  star:      'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
  bookmark:  'M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z',
  note:      'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z',
  question:  'M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01',
  sparkle:   'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
  chart:     'M18 20V10M12 20V4M6 20v-6',
  send:      'M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z',
  search:    'M11 17a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM21 21l-4.35-4.35',
  settings:  'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  highlight: 'M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z',
  video:     'M23 7l-7 5 7 5V7zM1 5h15v14H1z',
  play:      'M5 3l14 9-14 9V3z',
  zoomIn:    'M11 17a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM21 21l-4.35-4.35M11 8v6M8 11h6',
  zoomOut:   'M11 17a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM21 21l-4.35-4.35M8 11h6',
  copy:      'M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2M8 4h8M8 4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2',
  download:  'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3',
  menu:      'M3 12h18M3 6h18M3 18h18',
  plus:      'M12 5v14M5 12h14',
  trash:     'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6',
  pencil:    'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z',
  mcq:       'M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11',
  essay:     'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8',
  clock:     'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 6v6l4 2',
  eye:       'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6',
  trophy:    'M6 9H4.5a2.5 2.5 0 0 1 0-5H6M18 9h1.5a2.5 2.5 0 0 0 0-5H18M8 19h8M12 2v7M4 22h16M12 19v3',
  flag:      'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22v-7',
  refresh:   'M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15',
  list:      'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
};

export const PREVIEW_CSS = `
.ebk h1{font-size:2rem;font-weight:800;color:#0f172a;margin-bottom:1rem;border-bottom:3px solid #6366f1;padding-bottom:.5rem}
.ebk h2{font-size:1.5rem;font-weight:700;color:#1e293b;margin-top:2.5rem;margin-bottom:.75rem;padding-left:.75rem;border-left:4px solid #6366f1}
.ebk h3{font-size:1.2rem;font-weight:600;color:#334155;margin-top:1.75rem;margin-bottom:.5rem}
.ebk p{margin-bottom:1rem;color:#374151;line-height:1.85;font-size:1rem}
.ebk ul,.ebk ol{padding-left:1.75rem;margin-bottom:1rem}
.ebk li{margin-bottom:.35rem;color:#374151;line-height:1.7}
.ebk strong{font-weight:700;color:#0f172a}
.ebk a{color:#6366f1;text-decoration:underline}
.ebk hr{border:none;border-top:2px dashed #e2e8f0;margin:2.5rem 0}
.ebk blockquote{border-left:4px solid #6366f1;padding:.875rem 1.25rem;background:linear-gradient(to right,#f0f9ff,#fff);margin:1.5rem 0;border-radius:0 .75rem .75rem 0;font-style:italic;color:#475569}
.ebk code{background:#f1f5f9;color:#dc2626;padding:.125rem .375rem;border-radius:.3rem;font-size:.875em;font-family:monospace}
.ebk pre{background:#0f172a;color:#e2e8f0;padding:1.5rem;border-radius:.75rem;overflow-x:auto;margin-bottom:1.25rem}
.ebk pre code{background:transparent;color:#e2e8f0;padding:0}
.ebk table{width:100%;border-collapse:collapse;margin-bottom:1.25rem;border-radius:.75rem;overflow:hidden}
.ebk th{background:#6366f1;color:#fff;padding:.75rem 1rem;text-align:left;font-weight:600}
.ebk td{padding:.625rem 1rem;border-bottom:1px solid #f1f5f9}
.ebk tr:nth-child(even) td{background:#f8fafc}
.ebk img{max-width:100%;border-radius:.75rem;margin:1rem auto;display:block}
.callout{border-left:4px solid;padding:1rem 1.25rem;border-radius:0 .75rem .75rem 0;margin:1.25rem 0}
.callout-tip{background:#f0fdf4;border-color:#22c55e;color:#14532d}
.callout-warning{background:#fffbeb;border-color:#f59e0b;color:#78350f}
.callout-definition{background:#eff6ff;border-color:#3b82f6;color:#1e3a8a}
.callout-important{background:#fef2f2;border-color:#ef4444;color:#7f1d1d}
.callout-remember{background:#f5f3ff;border-color:#8b5cf6;color:#3b0764}
.callout-title{font-weight:700;margin-bottom:.35rem;font-size:.9rem}
.ebook-btn{display:inline-flex;align-items:center;padding:.6rem 1.25rem;border-radius:.5rem;font-weight:600;cursor:pointer}
.ebook-video-wrap{position:relative;border-radius:.75rem;overflow:hidden;margin:1.25rem 0;background:#000}
`;

const CALLOUT_META = {
  tip:        { icon: '💡', label: 'Tip' },
  warning:    { icon: '⚠️', label: 'Warning' },
  definition: { icon: '📖', label: 'Definition' },
  important:  { icon: '📌', label: 'Important' },
  remember:   { icon: '✅', label: 'Remember' },
};

export function processCustomBlocks(md) {
  let out = md.replace(/:::(\w+)\n([\s\S]*?):::/g, (_, type, body) => {
    const meta = CALLOUT_META[type];
    if (!meta) return `<div>${body}</div>`;
    return `<div class="callout callout-${type}"><div class="callout-title">${meta.icon} ${meta.label}</div>${body.trim()}</div>`;
  });
  out = out.replace(/:::video\n([\s\S]*?):::/g, (_, body) => {
    const p = {};
    body.trim().split('\n').forEach((l) => { const eq = l.indexOf('='); if (eq !== -1) p[l.slice(0, eq).trim()] = l.slice(eq + 1).trim(); });
    return `<div class="ebook-video-wrap"><iframe src="${p.url||''}" width="${p.width||'100%'}" height="${p.height||'360'}" title="${p.title||'Video'}" frameborder="0" allowfullscreen style="width:100%;display:block;"></iframe></div>`;
  });
  out = out.replace(/:::button\n([\s\S]*?):::/g, (_, body) => {
    const p = {};
    body.trim().split('\n').forEach((l) => { const eq = l.indexOf('='); if (eq !== -1) p[l.slice(0, eq).trim()] = l.slice(eq + 1).trim(); });
    const bg = p.color || '#6366f1'; const fg = p.textColor || '#ffffff';
    return `<div style="text-align:${p.align||'left'};margin:1.25rem 0"><a href="${p.url||'#'}" target="_blank" rel="noreferrer" class="ebook-btn" style="background:${bg};color:${fg}">${p.label||'Click here'}</a></div>`;
  });
  return out;
}

export const INPUT_CLS = 'w-full border border-slate-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 bg-white text-slate-800';
